import React from "react";
import { NavigationMenu } from "../navigation/NavigationMenu";
import { NavigationItem } from "../navigation/NavigationItem";
import {
    CreditCardIcon,
    DirectoryIcon,
    IntegrationsIcon,
    LockIcon,
    MembersIcon,
    PlansIcon,
} from "../../icons";
import { WorkspaceSettingsPages } from "./constants";
import { SettingsNavLink } from "./SettingsNavLink";

export const WorkspaceSettingsNavigation: React.FC = () => (
    <>
        <header className="settings__navigation__workspaces-header">
            Workspace
        </header>

        <NavigationMenu className="flex-column">
            <SettingsNavLink eventKey={WorkspaceSettingsPages.MEMBERS}>
                <NavigationItem icon={<MembersIcon />}>Members</NavigationItem>
            </SettingsNavLink>
            <SettingsNavLink eventKey={WorkspaceSettingsPages.INTEGRATIONS}>
                <NavigationItem icon={<IntegrationsIcon />}>
                    Integrations
                </NavigationItem>
            </SettingsNavLink>

            <SettingsNavLink eventKey={WorkspaceSettingsPages.DIRECTORY}>
                <NavigationItem icon={<DirectoryIcon />}>
                    Directory
                </NavigationItem>
            </SettingsNavLink>

            <SettingsNavLink eventKey={WorkspaceSettingsPages.LOCKS}>
                <NavigationItem icon={<LockIcon />}>Locks</NavigationItem>
            </SettingsNavLink>

            <SettingsNavLink eventKey={WorkspaceSettingsPages.PLANS}>
                <NavigationItem icon={<PlansIcon />}>Plans</NavigationItem>
            </SettingsNavLink>

            <SettingsNavLink eventKey={WorkspaceSettingsPages.BILLING}>
                <NavigationItem icon={<CreditCardIcon />}>
                    Billing
                </NavigationItem>
            </SettingsNavLink>
        </NavigationMenu>
    </>
);
